import { render, staticRenderFns } from "./IBS-info-modal.vue?vue&type=template&id=6f0ca7f6"
import script from "./IBS-info-modal.vue?vue&type=script&lang=js"
export * from "./IBS-info-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports